export const ENV = {
    dev: 'dev',
    prod: 'prod',
} as const;

async function initLivechat() {
    try {
        const id = getIdFromPath();
        const support = getSupportFromQuery();
        const apiBase = import.meta.env.VITE_API_BASE_URL || 'https://api-dev.twinny.es';
        const url = `${apiBase}/public/snippet/livechat/${id}`;
        const res = await fetch(url);
        const data = await res.json();

        const hasLoaded = !!window.TwinnySnippet;
        const scriptElement = document.getElementById('twinny-snippet');
        const forceLoadAttribute = scriptElement?.getAttribute('data-forceload') === 'true';
        const forceLoadGlobal = window.TwinnySnippet?.forceLoad;
        const forceLoad = forceLoadAttribute || forceLoadGlobal;

        // We need a div with id="container-instance" for the logic to trigger
        // Let's rename our test container on the fly or in HTML
        const container = document.getElementById("my-chat-container");
        if (container) container.id = "container-instance";

        if (hasLoaded) {
            initSnippet(data.snippet_id, id, forceLoad, support);
        } else {
            if (scriptElement) {
                scriptElement.onload = () => {
                    initSnippet(data.snippet_id, id, forceLoad, support);
                };
            }
        }
    } catch (error) {
        console.error('Unable to fetch livechat instance', error);
    }
}

function getIdFromPath(): string {
    // this code was set to use an ID when developing locally
    // but we need to be disable it to test in the remote development environment
    // ideally a third environment (named "local") should be created for this
    // so that we can use the same code in all environments (local, dev and prod)

    // const env = import.meta.env;

    // if (env.MODE === ENV.dev) {
    //     return env.VITE_DEMO_ID;
    // } else {
    const fragments = window.location.pathname.split('/');
    return fragments[fragments.length - 1];
    // }
}

function getSupportFromQuery(): boolean {
    const params = new URLSearchParams(window.location.search);
    return params.get('support') === 'true';
}

function initSnippet(
    id: string,
    aiAgentVersionId: string,
    forceLoad?: boolean,
    support?: boolean,
): void {
    if (window.TwinnySnippet) {
        window.TwinnySnippet.init({
            twid: id,
            aiAgentVersionId,
            container: 'container-instance',
            forceLoad,
            support,
        });
    } else {
        console.error('TwinnySnippet not found');
    }
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLivechat);
} else {
    initLivechat();
}
